<script setup lang="ts">
const props = defineProps<{
  src: string;
  title?: string;
  alt?: string;
}>();
</script>

<template>
  <img v-bind="$attrs" :src="props.src" :alt="props.alt" :title="props.title" />
</template>
